// extracted by mini-css-extract-plugin
module.exports = {"summaryContainer":"JobRequestSummary_summaryContainer__3wTJ4","title":"JobRequestSummary_title__20ljX","value":"JobRequestSummary_value__1v5sP"};